module.exports = __webpack_public_path__ + "static/media/presents.10ac1682.svg";